import React, {useState, useEffect} from 'react'
import {getCountry} from "../../../../Utils/countries";
import {MDBBtn} from "mdbreact";

const ApprovalItem = (props) => {
    const [isLocked, setIsLocked] = useState(false)
    return (
        <tr key={props.data.id}>
            <td>{props.index + 1}</td>
            <td>{props.data.category}</td>
            <td>{props.data.type}</td>
            <td>{props.data.title}</td>
            <td>{typeof props.data.country !== 'undefined' && props.data.country !== '' ? getCountry(props.data.country).label : ""}</td>
            <td>
                <MDBBtn color={'link'} href={props.data.url} target={"_blank"}>
                    Link
                </MDBBtn>
                <MDBBtn color={'success'}
                        disabled={isLocked}
                        onClick={() => {
                            setIsLocked(true)
                            props.approvalItem(props.data.id)
                        }}
                >
                    Approval
                </MDBBtn>
                <MDBBtn color={'danger'} disabled={isLocked} outline
                        onClick={() => {
                            setIsLocked(true)
                            props.rejectItem(props.data.id)
                        }}
                >
                    Reject
                </MDBBtn>
            </td>
        </tr>
    )
}
export default ApprovalItem